<template>
  <ul class="ret-tree">
    <li v-for="node in nodes" :key="node.id"
        class="ret-tree">
      <div class="ret-tree-ico" @click.stop="onIcoClick(node)">
        <v-icon v-if="node.children.length == 0">remove</v-icon>
        <v-icon v-else-if="!node.opened">keyboard_arrow_right</v-icon>
        <v-icon v-else-if="node.opened">keyboard_arrow_down</v-icon>
      </div>
      <div class="ret-tree-item" @click.stop="onItemClick(node.id)">
        {{ node.name || 'No name' }}
      </div>
      <ret-tree :model="model" :nodes="node.children" @itemClick="onItemClick"
                v-if="node.hasChildren() && node.opened"></ret-tree>
    </li>
  </ul>
</template>

<style scoped>
  li.ret-tree {
    list-style-type: none;
    cursor: pointer;
    padding-top: 16px;
  }

  div.ret-tree-ico {
    display: inline-block;
    padding-right: 8px;
  }

  div.ret-tree-item {
    display: inline-block;
  }

  ul.ret-tree > li.ret-tree {
    margin-left: 32px;
  }
</style>

<script>
//  import Vue from 'vue'
import RetTree from './ret-tree.vue'

export default {
  name: 'ret-tree',
  props: {
    model: Object,
    nodes: Array
  },
  // data () {
  //   return {
  //     opened: false
  //   }
  // },
  methods: {
    onIcoClick (item) {
      // console.log(item)
      // console.log(item === this.nodes[0])
      // console.log(item === this.$store.state.items.owners.nodes[0])
      item.opened = !item.opened
      // Vue.set(item, 'opened', !item.opened)
    },
    onItemClick (itemId) {
      this.$emit('itemClick', itemId)
    }
  },
  components: {
    RetTree
  }
}
</script>
